<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- url="https://api-admin.nextdesign-e.com/api/v1/auth/uploadPhoto" @src-file-set="changePhoto"-->
<template>
  <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <!-- <img src="/img/avatar-s-3.7ed1da4a.jpg" class="mr-8 rounded h-24 w-24" /> -->
          <vs-avatar :src="this.$store.state.userManagement.userProfile.photo === '/' || !this.$store.state.userManagement.userProfile.photo ? null : this.$store.state.userManagement.userProfile.photo" size="80px" id="user_photo" class="mr-4" />
          <my-upload field="file"
							:width="300"
							:height="300"
							v-model="show"
              id="photo_field"
							method="POST"
							@crop-success="changePhoto"
							lang-type="pt-br"
							:value.sync="show"
							:noSquare="true"
							img-format="png">
						</my-upload>
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ this.$store.state.userManagement.userProfile.name }}</p>
            <input type="file" class="hidden" ref="update_avatar_input" id="update_avatar" accept="image/*" @change="update_avatar">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mr-4 mb-4" @click="call_update_avatar" data-state="initial" id="update_avatar_btn">{{ $t('ROLES.ChangeAvatar') }}</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button type="border" color="danger" id="remove_avatar" @click="removeAvatar" data-state="initial">{{ $t('ROLES.RemoveAvatar') }}</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Username" :value="this.$store.state.userManagement.userProfile.username" disabled @input="setUsername" name="username" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

        <vs-input class="w-full mt-4" label="Name" v-validate="'required'" name="name"  :value="this.$store.state.userManagement.userProfile.name" @input="setName" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="Email" :value="this.$store.state.userManagement.userProfile.email" type="email" disabled name="email" />
      </div>

      <div class="vx-col md:w-1/2 w-full">

        <!-- <div class="mt-4">
          <label class="vs-input--label">Status</label>
          <v-select v-model="local_status" :clearable="false" :options="statusOptions" v-validate="'required'" name="status" disabled :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div> -->

        <vs-input class="w-full mt-4" label="Status" v-model="this.$store.state.userManagement.userProfile.status_name" disabled name="status" />

        <vs-input class="w-full mt-4" label="Cargo" v-model="this.$store.state.userManagement.userProfile.role_name" disabled name="role" />

        <!-- <vs-input class="w-full mt-4" label="Company" v-model="data_local.company" v-validate="'alpha_spaces'" name="company" />
        <span class="text-danger text-sm"  v-show="errors.has('company')">{{ errors.first('company') }}</span> -->

      </div>
    </div>

    <!-- Permissions -->
    <vx-card class="mt-base" no-shadow card-border>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="CalendarIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">{{ $t('ROLES.calendar') }}s</span>
          </div>
          <vs-divider />
        </div>
      </div>

      <div class="block overflow-x-auto" v-if="userCalendars.length > 0">
        <table class="w-full">
          <tr>
            <!--
              You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
              our data structure. You just have to loop over above variable to get table headers.
              Below we made it simple. So, everyone can understand.
             -->
            <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Módulo', 'Exibir']" :key="heading">{{ heading }}</th>
          </tr>

          <tr v-for="(item, index) in userCalendars" :key="index">
            <td class="px-3 py-2">{{ item.calendarName }}</td>
            <td class="px-3 py-2">
              <vs-checkbox v-model="item.calendarView" @change="changeCheckbox($event, item.calendarHash)"/>
            </td>
          </tr>
        </table>
      </div>
      <div v-else><span>{{ $t('PROFILE.NoCalendarsToDisplay') }}</span></div>

    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{ $t('PROFILE.SaveChanges') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import myUpload from 'vue-image-crop-upload'
import { getApplicationLocalStorageItem, setApplicationLocalStorageItem } from '../../../helpers'
export default {
  components: {
    vSelect,
    'my-upload': myUpload
  },
  data () {
    return {

      show: false,

      user_data: {
        name: this.$store.state.userManagement.userProfile.name
      },

      update_avatar_data: null,

      data_local: null,

      local_status: {label: this.$store.state.userManagement.userProfile.status_id, value: this.$store.state.userManagement.userProfile.status_name},

      local_role: 'admin',

      local_permissions: {
        comments: {read: true},
        posts: {read: true},
        users: {read: true}
      },
      userCalendars: [],

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  async created () {
    setTimeout(async () => {
      if (this.$store.state.userManagement.userProfile.photo !== '/') {
        const tester = new Image()
        tester.onerror = () => {
          this.$store.commit('userManagement/SET_PHOTO', '/')
        }
        tester.src = this.$store.state.userManagement.userProfile.photo
      }

      await this.$store.dispatch('userManagement/getUserCalendars')
      this.userCalendars = JSON.parse(JSON.stringify(this.$store.state.userManagement.userProfile.calendars))

    }, 300)
    setApplicationLocalStorageItem('validate-count', 0)
  },
  // watch: {
  //   userCalendars(newValue) {
  //     console.log(newValue)
  //     this.$store.state.userManagement.userProfile.calendars = newValue
  //   }
  // },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.local_status),  value: this.local_status  }
      },
      set (obj) {
        this.local_status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.local_role),  value: this.local_role  }
      },
      set (obj) {
        this.local_role = obj.value
      }
    },
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')

      if (!this.$store.state.userManagement.userProfile.name) {
        this.errors.add({field: 'name', msg: 'The name field is required'})
        return false
      } else if (/\d/.test(this.$store.state.userManagement.userProfile.name)) {
        this.errors.add({field: 'name', msg: 'The name field may only contain alphabetic characters as well as spaces'})
        return false
      } else if (!specialRegex.test(this.$store.state.userManagement.userProfile.name)) {
        this.errors.add({field: 'name', msg: 'The name field may contain alpha-numeric characters as well as dashes and underscores'})
        return false
      } else {
        this.errors.clear()
      }

      if (this.$store.state.userManagement.userProfile.languages && this.$store.state.userManagement.userProfile.languages.length === 0) {
        if (parseInt(getApplicationLocalStorageItem('validate-count')) === 0) {
          this.$vs.notify({
            title: 'Warning',
            text: 'The languages field in Information Tab is required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false

          setApplicationLocalStorageItem('validate-count', 1)
        }

        if (!this.$store.state.userManagement.userProfile.name) {
          this.errors.add({field: 'name', msg: 'The name field is required'})
          return false
        } else if (/\d/.test(this.$store.state.userManagement.userProfile.name)) {
          this.errors.add({field: 'name', msg: 'The name field may only contain alphabetic characters as well as spaces'})
          return false
        } else if (!specialRegex.test(this.$store.state.userManagement.userProfile.name)) {
          this.errors.add({field: 'name', msg: 'The name field may contain alpha-numeric characters as well as dashes and underscores'})
          return false
        } else {
          this.errors.clear()
        }

        // if(/\d/.test(this.$store.state.userManagement.userProfile.website)) {
        //   this.errors.add({field: 'website', msg: 'The website field may only contain alphabetic characters as well as spaces'})

        //   this.$vs.notify({
        //     title: 'Warning',
        //     text: 'Check all fields',
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'warning'
        //   })

        //   return false
        // }

        // if(/[`!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(this.$store.state.userManagement.userProfile.website)) {
        //   this.errors.add({field: 'website', msg: 'The website field may contain alpha-numeric characters as well as dashes and underscores'})

        //   this.$vs.notify({
        //     title: 'Warning',
        //     text: 'Check all fields',
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'warning'
        //   })

        //   return false
        // }

        return false
      }

      if (parseInt(getApplicationLocalStorageItem('validate-count')) === 0) {

        if (!this.$store.state.userManagement.userProfile.name) {
          this.errors.add({field: 'name', msg: 'The name field is required'})
          return false
        } else if (/\d/.test(this.$store.state.userManagement.userProfile.name)) {
          this.errors.add({field: 'name', msg: 'The name field may only contain alphabetic characters as well as spaces'})
          return false
        } else if (!specialRegex.test(this.$store.state.userManagement.userProfile.name)) {
          this.errors.add({field: 'name', msg: 'The name field may contain alpha-numeric characters as well as dashes and underscores'})
          return false
        } else {
          this.errors.clear()
        }

        if (this.$store.state.userManagement.userProfile.mobile && this.$store.state.userManagement.userProfile.mobile.length < 10 && this.$store.state.userManagement.userProfile.mobile.length > 0) {

          this.errors.add({field: 'mobile', msg: 'The Mobile field is incomplete'})

          this.$vs.notify({
            title: 'Warning',
            text: 'Check all fields',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }

        setApplicationLocalStorageItem('validate-count', 1)
      }

      if (/\s/.test(this.$store.state.userManagement.userProfile.name) && this.$store.state.userManagement.userProfile.name.trim() === '') {
        this.errors.add({field: 'name', msg: 'The name field may be a valid name'})

        return false
      }

      return !this.errors.any()
    }
  },
  methods: {
    changeCheckbox(e, calendarHash) {
      const value = e.target.value === 'true' ? false : true

      this.$store.commit('userManagement/SET_USER_CALENDAR', {value: value, calendarHash: calendarHash})
    },
    validUrl (url) {
      setTimeout(() => {
        if (url) {
          if (url.split('.')[1] === 'png' || url.split('.')[1] === 'jpg' || url.split('.')[1] === 'jpeg') {
            return true
          } else {
            return false
          }
        }
      }, 300)
    },
    validBase64 (str) {
      setTimeout(() => {
        if (str) {
          if (str.substring(str.length - 2) === '==') {
            return /[A-Za-z0-9+/=]/.test(str)
          } else {
            return false
          }
        }
      }, 300)
    },
    toggleShow () {
      this.show = !this.show
    },
    setUsername (e) {
      this.$store.commit('userManagement/SET_USERNAME', e)
    },
    setName (e) {
      this.$store.commit('userManagement/SET_NAME', e)
    },

    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    removeAvatar () {
      this.$store.commit('userManagement/setAvatar', null)
    },
    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('userManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('userManagement/setUserProfile', res)
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    },
    save_changes () {

      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('userManagement/saveChanges', {userProfile: this.$store.state.userManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        await this.fetch_user_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)

        this.$store.commit('auth/SET_USER_NAME', this.$store.state.userManagement.userProfile.name)
        this.$store.commit('auth/SET_USER_PHOTO', this.$store.state.userManagement.userProfile.photo)
        this.$store.commit('auth/SET_USER_USERNAME', this.$store.state.userManagement.userProfile.username)
        this.$store.commit('auth/SET_USER_MOBILE', this.$store.state.userManagement.userProfile.mobile)
        await this.$store.dispatch('userManagement/getUserCalendars')
        this.userCalendars = JSON.parse(JSON.stringify(this.$store.state.userManagement.userProfile.calendars))
        setApplicationLocalStorageItem('user', JSON.stringify(this.$store.state.auth.user))

        this.$vs.notify({
            title: this.$t('PROFILE.SuccessOperation'),
            text: this.$t('PROFILE.DataSuccessfullyChanged'),
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
      })
      .catch((err) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    call_update_avatar () {
      // document.querySelector("#update_avatar").click()
      this.toggleShow()
    },
    update_avatar (e) {
      e.preventDefault()
      this.toggleShow()
      const preview = document.querySelector('img')
      const file = document.querySelector('input[type=file]').files[0]
      const reader = new FileReader()

      const me = this

      reader.addEventListener('load', function () {
        const btn_save = document.querySelector('#update_avatar_btn')
        btn_save.innerText = me.$t('PROFILE.Cancel')
        const btn_cancel = document.querySelector('#remove_avatar')
        btn_cancel.innerText = 'Cancelar'
      }, false)

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    handlePreview (res, file) {
      this.changeImage(res.photo)
    },
    async changePhoto (imageDataUrl, field) {
      // console.log(imageDataUrl)
      this.$store.commit('userManagement/SET_PHOTO', imageDataUrl)
    }
  }
}
</script>
